import { CraMonth } from '@shared/types';
import { hubDb } from '@shared/storage/db';
import { useLiveQuery } from 'dexie-react-hooks';

function sortCras(records: CraMonth[]) {
  return [...records].sort((a, b) => `${b.year}-${b.month}`.localeCompare(`${a.year}-${a.month}`));
}

export function useCrasByProject(projectId: string | undefined) {
  return useLiveQuery(
    async () => {
      if (!projectId) return [] as CraMonth[];
      return sortCras(await hubDb.cras.where('projectId').equals(projectId).toArray());
    },
    [projectId],
    [] as CraMonth[],
  );
}

export function useCra(projectId: string | undefined, year: number, month: number) {
  return useLiveQuery(
    async () => {
      if (!projectId) return null;
      return (await hubDb.cras.where({ projectId, year, month }).first()) ?? null;
    },
    [projectId, year, month],
    null as CraMonth | null,
  );
}

export async function listCras(): Promise<CraMonth[]> {
  const records = await hubDb.cras.toArray();
  return sortCras(records);
}

export async function upsertCraRecord(record: CraMonth): Promise<CraMonth> {
  await hubDb.cras.put(record);
  return record;
}

export async function removeCraRecord(id: string): Promise<void> {
  await hubDb.cras.delete(id);
}
